<!-- 宏观总结 -->
<template>
  <div>
    <H3Title :title="'宏观总结'"></H3Title>
    <div class="txt" v-if="HGConclusion.marketEstimation">
      <div class="txt-top">
        <p class="txt-top-title">市场估值</p>
        <p>1.整体市场估值<span class="redchild" v-html="HGConclusion.marketEstimation"></span></p>
        <p>2.今日两市成交量<span class="redchild" v-html="HGConclusion.dualTurnover"></span></p>
        <p>3.两市总市值处于<span class="redchild" v-html="HGConclusion.dualMarketValue"></span></p>
      </div>
      <div class="txt-bottom">
        <p class="txt-bottom-title">货币流动性</p>
        <p>1.整体货币流动性<span class="redchild" v-html="HGConclusion.currencyLiquidity"></span></p>
        <p>2.M1处于历史 <span class="redchild" v-html="HGConclusion.M1"></span></p>
        <p>3.DR007处于 <span class="redchild" v-html="HGConclusion.DR007"></span></p>
      </div>
    </div>
  </div>
</template>

<script>
import H3Title from "@/components/H3Title";
export default {
  name: "HGConclusion",
  components: {
    H3Title
  },
  props: {
    elementId: {
      type: String,
      default: "hello"
    },
    HGConclusion: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  mounted() {
  }
};
</script>
<style lang="scss" scoped>
.txt {
  width: 100%;
  height: 250px;
  display: flex;
  min-width: 200px;
  flex-direction: column;
  justify-content: center;
  left: 10%;
  position: relative;
  top: 10px;
  font-size: 13px;
  p {
    line-height: 25px;
  }
 
  &-top {
    margin-bottom: 20px;
    &-title {
      font-size: 15px;
    }
  }
  &-bottom-title {
    font-size: 15px;
  }
}
</style>
<style>
 .redchild span {
    color: #fd4332;
  }
</style>